import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import {NgModule} from '@angular/core';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EinstiegComponent} from './einstieg/einstieg.component';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {PortalService} from '../services/portal.service';

/**
 * Routes for the bekocheck.
 * The default route leads to bekocheck here
 */
const routes: Routes = [
  { path: ':portalId/bekocheck', children: [
      // default step is 'eingabe'
      { path: '', redirectTo: 'start', pathMatch: 'full' },
      // list of all available steps in the advisor
      // first input section
      { path: 'kurz', component: EinstiegComponent},
      { path: 'start', component: EingabeStartComponent},
      { path: 'eingabe/start', redirectTo: 'start', pathMatch: 'full'},
      { path: 'eingabe', component: StepChapterComponent, children: [
          { path: 'basisdaten/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
          { path: 'basisdaten/2', component: EingabeStepComponent, data: {swipeCount: '30'}},
          { path: 'basisdaten/3', component: EingabeStepComponent, data: {swipeCount: '40'}},
          { path: 'basisdaten/4', component: EingabeStepComponent, data: {swipeCount: '50'}},
          { path: 'basisdaten/5', component: EingabeStepComponent, data: {swipeCount: '60'}},
          { path: 'basisdaten/6', component: EingabeStepComponent, data: {swipeCount: '70'}},
          { path: 'basisdaten/7', component: EingabeStepComponent, data: {swipeCount: '80'}},
          { path: 'basisdaten/8', component: EingabeStepComponent, data: {swipeCount: '90'}},
          { path: 'basisdaten/9', component: EingabeStepComponent, data: {swipeCount: '100'}},
          { path: 'abrechnung/1', component: EingabeStepComponent, data: {swipeCount: '110'}},
          { path: 'abrechnung/2', component: EingabeStepComponent, data: {swipeCount: '120'}},
          { path: 'abrechnung/3', component: EingabeStepComponent, data: {swipeCount: '130'}},
          { path: 'abrechnung/4', component: EingabeStepComponent, data: {swipeCount: '140'}},
          { path: 'abrechnung/5', component: EingabeStepComponent, data: {swipeCount: '150'}},
          { path: 'abrechnung/6', component: EingabeStepComponent, data: {swipeCount: '160'}},
          { path: 'abrechnung/7', component: EingabeStepComponent, data: {swipeCount: '170'}},
          { path: 'abrechnung/8', component: EingabeStepComponent, data: {swipeCount: '180'}},
          { path: 'abrechnung/9', component: EingabeStepComponent, data: {swipeCount: '190'}},
          { path: 'heizung-und-wasser/1', component: EingabeStepComponent, data: {swipeCount: '200'}},
          { path: 'heizung-und-wasser/2', component: EingabeStepComponent, data: {swipeCount: '210'}},
          { path: 'heizung-und-wasser/3', component: EingabeStepComponent, data: {swipeCount: '220'}},
          { path: 'heizung-und-wasser/4', component: EingabeStepComponent, data: {swipeCount: '230'}},
          { path: 'heizung-und-wasser/5', component: EingabeStepComponent, data: {swipeCount: '240'}},
          { path: 'heizung-und-wasser/6', component: EingabeStepComponent, data: {swipeCount: '250'}},
          { path: 'heizung-und-wasser/7', component: EingabeStepComponent, data: {swipeCount: '260'}},
          { path: 'heizung-und-wasser/8', component: EingabeStepComponent, data: {swipeCount: '270'}},
          { path: 'heizung-und-wasser/9', component: EingabeStepComponent, data: {swipeCount: '280'}},
          { path: 'heizung-und-wasser/10', component: EingabeStepComponent, data: {swipeCount: '285'}},
          { path: 'hauswart/1', component: EingabeStepComponent, data: {swipeCount: '290'}},
          { path: 'hauswart/2', component: EingabeStepComponent, data: {swipeCount: '300'}},
          { path: 'hauswart/3', component: EingabeStepComponent, data: {swipeCount: '310'}},
          { path: 'hauswart/4', component: EingabeStepComponent, data: {swipeCount: '320'}},
          { path: 'weitere-kostenpositionen/1', component: EingabeStepComponent, data: {swipeCount: '330'}},
          { path: 'weitere-kostenpositionen/2', component: EingabeStepComponent, data: {swipeCount: '340'}},
          { path: 'weitere-kostenpositionen/3', component: EingabeStepComponent, data: {swipeCount: '350'}},
          { path: 'weitere-kostenpositionen/4', component: EingabeStepComponent, data: {swipeCount: '360'}},
          { path: 'weitere-kostenpositionen/5', component: EingabeStepComponent, data: {swipeCount: '370'}},
          { path: 'weitere-kostenpositionen/6', component: EingabeStepComponent, data: {swipeCount: '380'}},
          { path: 'weitere-kostenpositionen/7', component: EingabeStepComponent, data: {swipeCount: '390'}},
          { path: 'weitere-kostenpositionen/8', component: EingabeStepComponent, data: {swipeCount: '400'}},
          { path: 'weitere-kostenpositionen/9', component: EingabeStepComponent, data: {swipeCount: '410'}},
          { path: '', redirectTo: 'basisdaten/1', pathMatch: 'full' },
      ]},
      // last section with result page
      { path: 'ergebnis', component: StepChapterComponent, children: [
          { path: 'betriebskostenanalyse', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'bekocheck'}},
          { path: '', redirectTo: 'betriebskostenanalyse', pathMatch: 'full' },
        ]},
    ]},
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/bekocheck', pathMatch: 'full'},
  {path: 'bekocheck/', redirectTo: PortalService.defaultPortal + '/bekocheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/bekocheck', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class BekocheckRoutingModule { }
